export default "__VITE_ASSET__C8wG8b_z__"